import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PrimaryHeaderContainer } from './styles';

class PrimaryHeader extends Component {
    render() {
        const headerText = this.props.headerText;

        return <PrimaryHeaderContainer>{headerText}</PrimaryHeaderContainer>;
    }
}

PrimaryHeader.propTypes = {
    headerText: PropTypes.string.isRequired
};

export default PrimaryHeader;
